(ns ui.gallery.selection-bar
  "The bar at the viewport bottom of the Replicant gallery that slides
   in as soon as one gallery entry is selected: the count, 'Select all',
   the 'Move' popover, archive / restore and delete."
  (:require [storrito.ui.button :as button]
            [ui.gallery.move-popover :as move-popover]
            [ui.gallery.selection :as selection]))

(defn bulk-button
  [{:keys [icon label confirm command]}]
  [:button
   {:class (concat button/button-primary-css ["mx-2"])
    :type "button"
    :on {:click (cond-> []
                  confirm (conj [:js/confirm confirm])
                  true (conj [:gallery/bulk-command command]))}}
   [:span [:i.fas {:class icon}]]
   [:span.sm:block.hidden.ml-2 label]])

(defn selection-bar
  "It stays mounted while it is invisible, so it can slide in and out."
  [gallery folder-tree entry-count]
  (let [visible? (boolean (seq (:selected gallery)))
        selected-count (selection/display-count gallery)]
    [:div.fixed.left-0.bottom-0.w-full.flex.justify-center.pointer-events-none
     {:style {:z-index 2000}}
     [:div.bg-white.rounded-md.text-gray-700.shadow-lg.transition-all.duration-300.ease-out.flex.justify-between.items-center
      {:class (if visible?
                ["translate-y-0" "opacity-100" "pointer-events-auto"]
                ["translate-y-full" "opacity-0" "pointer-events-none"])
       :style {:padding "10px"}}
      [:button.mx-2
       {:type "button"
        :title "Deselect all"
        :on {:click [[:gallery/clear-selection]]}}
       [:i.fas.fa-times-circle.text-black.cursor-pointer.fa-2x]]
      [:p {:style {:margin "0px 10px"}}
       (str selected-count " selected")
       (when (< selected-count (or entry-count 0))
         [:a.underline.cursor-pointer.ml-2
          {:on {:click [[:gallery/select-all]]}}
          (str "Select all " entry-count)])]
      [:div.flex
       (when (= :active (:mode gallery :active))
         (move-popover/move-popover gallery folder-tree))
       (if (= :archive (:mode gallery))
         (bulk-button {:icon "fa-box-open"
                       :label "Restore"
                       :command :command/gallery-unarchive})
         (bulk-button {:icon "fa-box"
                       :label "Archive"
                       :command :command/gallery-archive}))
       (bulk-button {:icon "fa-trash"
                     :label "Delete"
                     :confirm "Do you like to delete the selected story media item(s)?"
                     :command :command/gallery-delete})]]]))
